import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { referenceApis } from '../apis';

const initialState = {
  loading: 'idle',
  data: [],
};

const fetchNetworks = createAsyncThunk('networks/fetch', async query => {
  const response = await referenceApis.fetchNetworks(query);
  return response.data;
});

const fetchServicePrices = createAsyncThunk(
  'networks/fetchServicePrices',
  async (query, { rejectWithValue }) => {
    try {
      const response = await referenceApis.fetchServicePrices(query);
      return response?.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

const networksSlice = createSlice({
  name: 'networks',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder.addCase(fetchNetworks.fulfilled, (state, action) => {
      state.data = action.payload;
    });
  },
});

const getNetworks = state => state.networks.data || [];

export const networksReducer = networksSlice.reducer;

export const networksActions = {
  fetchNetworks,
  fetchServicePrices,
};

export const networksSelectors = {
  getNetworks,
};
